// native
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

// service
import { CollectionsService } from './collections.service';

// models
import { IDisplayItem } from '../../models';

// constants
import { JANSSEN_COLLECTION_ID, JANSSEN_ORG_ID, JANSSEN_TEST_COLLECTION_ID, JANSSEN_TEST_ORG_ID, RC_TEST_COLLECTION_ID, RC_TEST_ORG_ID } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class MatcherService {
  matcherCollectionId: string;

  itemsIdsMatched: { originalId: string; id: string; }[] = [];

  itemsToMatch$: BehaviorSubject<IDisplayItem[]> = new BehaviorSubject([]);
  currentItem$: BehaviorSubject<IDisplayItem> = new BehaviorSubject(null);
  allItemsIdsMatched$: Subject<{ originalId: string; id: string; }[]> = new Subject();

  constructor(
    private collectionService: CollectionsService
  ) { }

  addMatch(originalId: string, id: string) {
    this.itemsIdsMatched.push({ originalId, id });
  }

  setMatcherCollection(organizationId: number) {
    if (organizationId === JANSSEN_ORG_ID)
      this.matcherCollectionId = JANSSEN_COLLECTION_ID;
    else if (organizationId === JANSSEN_TEST_ORG_ID)
      this.matcherCollectionId = JANSSEN_TEST_COLLECTION_ID;
    else if (organizationId === RC_TEST_ORG_ID)
      this.matcherCollectionId = RC_TEST_COLLECTION_ID;
  }

  get unmatchedTargetLibraryId(): string {
    if (!this.matcherCollectionId)
      return null;

    const matcherLibrary = this.collectionService.collections?.find(collection => collection.id === this.matcherCollectionId);
    return matcherLibrary?.user?.can_manage_item ? matcherLibrary.id : null;
  }
}
